import { jsx as r, jsxs as n } from "react/jsx-runtime";
import { twMerge as m } from "tailwind-merge";
import { GradientButton as s } from "../../../components/button/button.mjs";
import { StarsIcon as a } from "../../../icons/stars-icon.mjs";
const p = ({ className: o, onClick: t, disabled: e }) => /* @__PURE__ */ r(
  s,
  {
    className: m(
      "min-h-6.5 h-6.5 gap-0 rounded-sm border-none px-2 py-0 text-sm font-bold",
      o
    ),
    onClick: t,
    disabled: e,
    children: /* @__PURE__ */ n("div", { className: "flex items-center", children: [
      /* @__PURE__ */ r(a, { className: "h-5 w-5", color: "currentColor" }),
      /* @__PURE__ */ r("span", { children: "AI Chat" })
    ] })
  }
);
export {
  p as AiChatButton
};
